import { Settings } from "Models/ReduxModels/Settings";

export const getRestaurantsList = async (searchText, restaurantName, token, location?: string, locationStatus?: string, isCTASearch?: boolean) => {
  let state: any;
  const settings = Settings.getInsatnce("", state).props;
  const endPoint = settings["clientDetails"]?.restaurantService;
  const serviceOrigin = settings["clientDetails"]?.restaurantServiceOrigin;

  let headers = {
    Origin: serviceOrigin,
    "Content-type": "application/json",
    "X-Consumer-Token": `${token}`
  };

  const url = new URL(endPoint);

  if (isCTASearch) {
    // CTA "Search restaurants" button: selected restaurant name → "restaurantName", typed location → "aroundLocation"
    if (restaurantName) {
      url.searchParams.append("restaurantName", restaurantName);
    }
    if (searchText) {
      url.searchParams.append("aroundLocation", searchText);
    }
  } else {
    // Auto-suggest while typing: typed restaurant name → "searchString"
    url.searchParams.append("searchString", restaurantName);
  }

  // Pass GPS coordinates only when no location text is typed
  if (locationStatus === "accepted" && location && !searchText) {
    url.searchParams.append("aroundLatLng", location);
  }

  try {
    const resp = await fetch(url.toString(), {
      method: "GET",
      headers: headers
    });
    const data = await resp.json();
    if (data) {
      return data;
    }
  } catch (e) {
    console.error(e);
    return e;
  }
};
